import { useMemo, useState } from 'react';
import Dropdown from '../../../Components/Form/Inputs/Dropdown';
import { SelectInputOption } from '../../../Components/Form/Inputs/SelectInput';
import ComponentHeader from '../../../Components/Headers/ComponentHeader';
import useLanguage from '../../../Services/Language/useLanguageHook';
import CmeSpotSummary from '../../Dashboard/CmeSpotSummary/CmeSpotSummary';
import EuropeanUnionWeeklySummary from '../../Dashboard/EuropeanUnionWeeklySummaries/EuropeanUnionWeeklySummary';
import GlobalDairyTradeSummary from '../../Dashboard/GlobalDairyTradeSummary/GlobalDairyTradeSummary';
import styles from './CustomDefaultDashboardComponents.module.scss';

export type SummaryTableTypes = 'GlobalDairyTradeSummary' | 'CmeSpotSummary' | 'EuropeanUnionWeeklySummary';

interface ICustomDashboardPriceSummariesProps {
    useDynamicHeight?: boolean;
}

const CustomDashboardPriceSummaries: React.FC<ICustomDashboardPriceSummariesProps> = ({ useDynamicHeight }) => {
    const [translations] = useLanguage();
    const [title, setTitle] = useState<string | React.ReactNode>();

    const dropdownOptions: SelectInputOption<SummaryTableTypes>[] = useMemo(
        () => [
            {
                label: translations.dashboard.priceSummary.europeanUnion.summaryHeader,
                value: 'EuropeanUnionWeeklySummary',
            },
            {
                label: translations.dashboard.priceSummary.cme.summaryHeader,
                value: 'CmeSpotSummary',
            },
            {
                label: translations.dashboard.headings.globalDairyTradeResultTableHeading,
                value: 'GlobalDairyTradeSummary',
            },
        ],
        [translations],
    );
    const [selectedSummary, setSelectedSummary] = useState<SummaryTableTypes>('GlobalDairyTradeSummary');

    const containerClassName = useDynamicHeight ? styles.price_summary_container_dynamic_height : styles.price_summary_container;

    return (
        <div className={containerClassName}>
            <div className={styles.price_summary_header}>
                <ComponentHeader title={title} useContainerFontSize />
                <div className={styles.price_summary_header_dropdown}>
                    <p>{translations.dashboard.priceSummary.dropdownPrefix} </p>
                    <Dropdown
                        value={selectedSummary}
                        options={dropdownOptions}
                        handleOptionChange={(value) => {
                            setSelectedSummary(value);
                        }}
                        testId="PriceSummariesDropdown"
                        track={{ eventCategory: 'Dashboard', eventAction: 'PriceSummaryChanged', eventValue: selectedSummary }}
                    />
                </div>
            </div>
            <div className={styles.gdt_table_inner_style}>
                {selectedSummary === 'GlobalDairyTradeSummary' && <GlobalDairyTradeSummary setTitle={setTitle} />}
                {selectedSummary === 'CmeSpotSummary' && <CmeSpotSummary setTitle={setTitle} />}
                {selectedSummary === 'EuropeanUnionWeeklySummary' && <EuropeanUnionWeeklySummary setTitle={setTitle} />}
            </div>
        </div>
    );
};

export default CustomDashboardPriceSummaries;
